import React from "react";
import { Box, Typography, Grid, useMediaQuery } from "@mui/material";
import { styled } from "@mui/system";
import QrImage from "./img/qr-section.png";

const StyledImage = styled("img")({
  width: "100%",
  height: "auto",
  borderRadius: "12px",
});

const QRGeneratorSection = () => {
  const isMobile = useMediaQuery("(max-width:768px)");

  return (
    <Box
      sx={{
        background: "linear-gradient(135deg, #c5e3f5 0%, #ddeffa 100%)",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          py: { xs: 5, md: 10 },
          px: { xs: 2, md: 8 },
          width: { xl: "74%", lg: "79%", md: "90%", sm: "90%" },
        }}
      >
        <Grid container spacing={isMobile ? 4 : 8} alignItems="center">
          {/* Left Image Section */}
          <Grid item xs={12} md={6} display={{ xs: "none", md: "block" }}>
            <StyledImage src={QrImage} alt="QR Features" />
          </Grid>

          {/* Right Content Section */}
          <Grid item xs={12} md={6}>
            <Typography
              variant={isMobile ? "h5" : "h4"}
              fontWeight="bold"
              mb={2}
              color="#111827"
            >
              Why Should I Use a{" "}
              <span style={{ color: "#00D084" }}>WhatsApp</span> QR Code
              Generator?
            </Typography>

            <Typography variant="body1" color="#4b5563" mb={3} fontSize="18px">
              With a WhatsApp QR code generator, you can address issues such as
              overlooked opportunities, diminishing salesand disconnected
              contacts, seamlessly connecting you with customers and prospects.
            </Typography>

            <Box display={{ xs: "block", md: "none" }} pb={2}>
              <StyledImage src={QrImage} alt="QR Features" />
            </Box>

            <Typography variant="h6" fontWeight="bold" mb={1} color="#111827">
              Engage Audiences Swiftly
            </Typography>
            <Typography variant="body1" color="#4b5563" mb={3} fontSize="18px">
              With just a few clicks, set up a direct QR code that enables
              individuals without your contact details to initiate communication
              via WhatsApp Business.
            </Typography>

            <Typography variant="h6" fontWeight="bold" mb={1} color="#111827">
              Improve Your Business Processes
            </Typography>

            <Typography variant="body1" color="#4b5563" mb={3} fontSize="18px">
              Improve your communication strategies, boost engagementand enrich
              customer experience by allowing customers and prospective clients
              to reach you instantly.
            </Typography>

            <Typography variant="h6" fontWeight="bold" mb={1} color="#111827">
              Unlock Revenue Growth
            </Typography>

            <Typography variant="body1" color="#4b5563" fontSize="18px">
              Access untapped revenue potentials, boost your salesand heighten
              your profit margins by leveraging the power of personalised
              WhatsApp QR codes.
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default QRGeneratorSection;
